import axios from "axios";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const api = axios.create({ baseURL: API });

export const adminApi = () => {
  const token = sessionStorage.getItem("lh_admin_token");
  return axios.create({ baseURL: API, headers: token ? { Authorization: `Bearer ${token}` } : {} });
};

export const clientApi = () => {
  const token = sessionStorage.getItem("lh_client_token");
  return axios.create({ baseURL: API, headers: token ? { Authorization: `Bearer ${token}` } : {} });
};

export const formatError = (e) => {
  const d = e?.response?.data?.detail;
  if (!d) return e?.message || "Something went wrong.";
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return String(d);
};
